var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemSettings = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M8 14a4 4 0 0 1 3.874 3H21a1 1 0 0 1 .117 1.993L21 19h-9.126a4.002 4.002 0 0 1-7.748 0H3a1 1 0 0 1-.117-1.993L3 17h1.126c.444-1.725 2.01-3 3.874-3m0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8-8a4 4 0 0 1 3.874 3H21a1 1 0 0 1 .117 1.993L21 13h-1.126a4.002 4.002 0 0 1-7.748 0H3a1 1 0 0 1-.117-1.993L3 11h9.126c.444-1.725 2.01-3 3.874-3m0 2a2 2 0 1 0 .15.005zM8 2a4 4 0 0 1 3.874 3H21a1 1 0 0 1 .117 1.993L21 7h-9.126a4.002 4.002 0 0 1-7.748 0H3a1 1 0 0 1-.117-1.993L3 5h1.126C4.57 3.275 6.136 2 8 2m0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
})));
export default SvgGemSettings;